interface OnboardingPlanCardStateInput {
    loadingPlanId: string | null;
    planId: string;
    isUnavailable: boolean;
}

export const resolveOnboardingPlanCardState = ({
    loadingPlanId,
    planId,
    isUnavailable,
}: OnboardingPlanCardStateInput) => {
    const isSelectedPlanProcessing = loadingPlanId === planId;

    return {
        isSelectedPlanProcessing,
        isDisabled: isSelectedPlanProcessing || isUnavailable,
    };
};
